import React from 'react';

// Button component with various styles and sizes
export const Button = ({ 
  children, 
  className = '', 
  variant = 'default', 
  size = 'default',
  disabled = false,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  
  const variants = {
    default: 'bg-emerald-600 text-white hover:bg-emerald-700',
    ghost: 'hover:bg-slate-700 hover:text-white',
    outline: 'border border-slate-600 bg-transparent hover:bg-slate-700 text-slate-300 hover:text-white',
    secondary: 'bg-slate-700 text-white hover:bg-slate-600',
    destructive: 'bg-red-600 text-white hover:bg-red-700'
  };

  const sizes = {
    default: 'h-10 py-2 px-4',
    sm: 'h-9 px-3 rounded-md',
    lg: 'h-11 px-8 rounded-md',
    icon: 'h-10 w-10'
  };

  const variantClasses = variants[variant] || variants.default;
  const sizeClasses = sizes[size] || sizes.default;

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};